var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 46,
  viewBox: "0 0 34 46",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M32.808 25.388 2.842 45.442C1.272 46.493 0 46.016 0 44.371V1.608C0-.035 1.248-.496 2.797.584l30.056 20.952c1.545 1.077 1.528 2.8-.045 3.852"
})));
export default SvgChannelVideo;